import React, { useEffect, useState } from "react";
import { Button, Checkbox, Col } from "antd";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { Warehouse } from "../../../../redux/@types";
import { warehousesService } from "../../../../shared/services";
import { useParams } from "react-router-dom";
import { useProductWarehouses } from "../../../warehouses/hooks/productWerehouses/useProductWarehouses";
import Table from "../../../../shared/components/ui/Table";
import { useAssignProductWharehouse } from "../../../warehouses/hooks/productWerehouses";

interface Props {
  fetchQuery?: any;
}

export const TableWarehouses = ({ fetchQuery: _fetchQuery }: Props) => {
  const { id: productId } = useParams();
  const { productWarehouseInfo, productWarehouses } = useProductWarehouses({
    productId: +productId!,
  });
  const { assignProductWharehouse, removeProductWharehouse } =
    useAssignProductWharehouse();

  // Estado para almacenar las bodegas seleccionadas
  const [selectedWarehouseIds, setSelectedWarehouseIds] = useState<Set<number>>(
    new Set()
  );

  useEffect(() => {
    // Opcional: Puedes usar esta lógica si necesitas sincronizar con la información existente
    const activeIds = new Set(
      productWarehouseInfo
        .filter((info) => info.status === "active")
        .map((info) => info.warehouse_id)
    );
    setSelectedWarehouseIds(activeIds);
  }, [productWarehouseInfo]);

  // Maneja la selección o deselección de bodegas
  const handleCheckboxChange = (warehouseId: number, checked: boolean) => {
    setSelectedWarehouseIds((prev) => {
      const newSelection = new Set(prev);
      if (checked) {
        newSelection.add(warehouseId);
      } else {
        newSelection.delete(warehouseId);
      }
      return newSelection;
    });
  };

  // Maneja la asignación de bodegas seleccionadas al producto
  const handleAssignSelected = async () => {
    const selectedProductsArray = Array.from(selectedWarehouseIds);

    for (const warehouseId of selectedProductsArray) {
      await assignProductWharehouse({
        productId: +productId!,
        warehouseId: +warehouseId!,
      });
    }
    await productWarehouses();
    setSelectedWarehouseIds(new Set()); // Opcional: Limpia la selección después de la asignación
  };

  // Maneja la eliminación de bodegas seleccionadas del producto
  const handleRemoveSelected = async () => {
    const selectedProductsArray = Array.from(selectedWarehouseIds);
    for (const warehouseId of selectedProductsArray) {
      await removeProductWharehouse(+warehouseId!, +productId!);
    }
    await productWarehouses();
    setSelectedWarehouseIds(new Set()); // Opcional: Limpia la selección después de la eliminación
  };

  console.log(2345, selectedWarehouseIds);

  const columns: TableColumns<Warehouse> = [
    {
      title: "ID",
      width: 1,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 2,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Dirección",
      width: 2,
      dataIndex: "address",
      key: "address",
      filterType: "text",
    },
    {
      title: "Latitud",
      width: 2,
      dataIndex: "latitude",
      key: "latitude",
    },
    {
      title: "Longitud",
      width: 2,
      dataIndex: "longitude",
      key: "longitude",
    },
    {
      title: "Seleccionar",
      key: "operation",
      fixed: "right",
      width: 1,
      render: (_, item) => {
        const isChecked = selectedWarehouseIds.has(item.id);

        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Checkbox
              checked={isChecked}
              onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
            />
          </Col>
        );
      },
    },
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={handleAssignSelected}
        disabled={selectedWarehouseIds.size === 0}
        style={{ marginBottom: 16 }}
      >
        Asignar Productos
      </Button>
      <Button
        type="default"
        onClick={handleRemoveSelected}
        disabled={selectedWarehouseIds.size === 0}
        style={{ marginBottom: 16, marginLeft: 8 }}
      >
        Eliminar Productos
      </Button>
      <Table<Warehouse>
        columns={columns}
        fetchQueryProps={{
          $sort: { id: -1 },
        }}
        service={warehousesService}
      />
    </>
  );
};
